<template>
  <div>
    <b-card
      class="mb-2"
    >
      <!-- workspace name -->
      <b-row class="border-bottom mb-2">
        <b-col>
          <h4>Workspace Details</h4>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <!--
        <b-col class="ml-3">
          <workspace-logo :workspace-id="workspaceId" />
        </b-col>
      -->
        <b-col>
          <p><b>Workspace Name</b></p>
          <kbd>{{ workspaceName }}</kbd>
          <p class="mt-2">
            <b>Workspace ID</b>
          </p>
          <kbd>{{ workspaceId }}</kbd>
        </b-col>

      </b-row>
    </b-card>

    <b-card
      class="mb-2"
    >
      <!-- workspace tokens -->
      <b-row class="border-bottom mb-2">
        <b-col
          cols="10"
        >
          <h4>Workspace Tokens</h4>
          <p>These tokens are used to authenticate networks and services to send data to your PRYM Workspace</p>
        </b-col>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="float-right mb-1"
            @click="showAddTokenModal = true"
          >
            Add Token
          </b-button>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        :items="workspaceTokens"
        :fields="workspaceTokensFields"
        responsive="sm"
        class="mb-0"
      >
        <template #cell(actions)="data">
          <b-button
            variant="outline-primary"
            size="sm"
            class="mr-1"
            @click="copyToken(data.item.token)"
          >
            Copy
          </b-button>
        </template>
        <template #cell(token)="data">
          <!-- hide token with *** -->
          <kbd>{{ data.item.token.substring(0, 5) }}***</kbd>

        </template>

      </b-table>
    </b-card>

    <workspace-details-stats-1 />
    <workspace-details-stats-2 />

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BButton,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import WorkspaceDetailsStats1 from './WorkspaceDetailsStats1.vue'
import WorkspaceDetailsStats2 from './WorkspaceDetailsStats2.vue'
// import WorkspaceLogo from './WorkspaceLogo.vue'
import * as queries from '../../graphql/queries'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    WorkspaceDetailsStats1,
    WorkspaceDetailsStats2,
    // WorkspaceLogo,
  },
  data() {
    return {
      workspaceName: JSON.parse(localStorage.getItem('workspace')).name,
      workspaceId: JSON.parse(localStorage.getItem('workspace')).id,
      workspaceTokens: [],
      workspaceTokensFields: [
        { key: 'name', label: 'Name' },
        { key: 'token', label: 'Token' },
        { key: 'actions', label: 'Actions' },
      ],
      prewiewSrc: '',
    }
  },
  created() {
    this.getWorkspaceTokens()
  },
  methods: {
    async getWorkspaceTokens() {
      this.workspaceTokens = []
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      const workspaceTokens = await API.graphql({
        query: queries.getWorkspace,
        variables: { id: workspaceId },
      })
      this.workspaceTokens.push({
        name: 'Workspace Token 1',
        token: workspaceTokens.data.getWorkspace.workspacetoken,
      })
    },
    copyToken(token) {
      const el = document.createElement('textarea')
      el.value = token
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
    previewImage(event) {
      const input = event.target
      if (input.files && input.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.previewSrc = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
  },

}
</script>

<style>

</style>
